import {AssemblyView} from "../components";
import {useEffect} from "react";
import {LangState, useLangContext} from "../../../shared/features/Language";
import {useHistory, useLocation, useParams} from "react-router";
import {parseRawQueryString} from "../../../shared/tools";

export const AssemblyPage = () => {  const { search } = useLocation();
  const history = useHistory();
  const {sessionId} = useParams<{sessionId: string}>();
  const location = useLocation();
  const langContext = useLangContext();
  const { query } = parseRawQueryString(search);

  useEffect(() => {
    if (query.lang) {
      langContext.changeLang(query.lang as LangState);
    }
  },[]);

  useEffect(() => {
    history.push({
      pathname: location.pathname,
      search: `?lang=${langContext.lang}`,
    });
  }, [langContext.lang]);

  return <AssemblyView sessionId={sessionId}/>;
}
